import { AdminResponse, AdminState } from "./types";
import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "store/rootReducer";
import { signOut } from "features/authentication/authSlice";
const initialState: AdminState = {
  activeWidget: "DASHBOARD",
  response: { message: "", hasError: false },
};

const admin = createSlice({
  name: "adminSlice",
  initialState,
  reducers: {
    setActiveWidget(state, action) {
      state.activeWidget = action.payload;
    },
    setResponse(state, action) {
      state.response = action.payload;
    },
  },
});
export const { setActiveWidget, setResponse } = admin.actions;
export const selectActiveWidget = (state: RootState) =>
  state.admin.activeWidget;
export const selectResponse = (state: RootState) => state.admin.response;
export const setResponseMessage = (response: AdminResponse) => async (
  dispatch: any
) => {
  if (response.hasError && response.message.includes("403")) {
    dispatch(signOut());
  }
  dispatch(setResponse(response));
};
export default admin.reducer;
